module.exports = __webpack_public_path__ + "img/nodata-video.e7055e6a.png";